export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";